import '@polymer/polymer/polymer-legacy.js';
import { GeofireTools } from '../../modules/GeofireTools.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
Polymer({
  _template: html``,

  is: 'time-buckets',

  properties: {
    uid: String,
    userGroup: String
  },

  startTime: {
    type: Number
  },

  start: function (jobid, activeItem, uid, userGroup, itemKey, callback) {
    if (activeItem != '') {
      this.set('activeItem', activeItem);
    }
    var time = new Date().getTime();
    this.set('startTime', time);
  },

  stop: function (job, activeItem, uid, userGroup, teamMembers, startTime, stopTime, item, update, assessmentDetail, callback) {
    var ref = FirebaseWorker.ref('photoheight');
    var bucketKey = ref.push().key;
    update = update || {};
    var typeKey = activeItem[0];
    var activeItemSplit = activeItem.slice(1).split(':');
    var bucket = {
      start: startTime,
      stop: stopTime,
      uid: uid,
      teamMembers
    };
    let fieldCompleted = SquashNulls(typeKey === 's' ? item.multi_attributes : item.attributes, 'field_completed') || {};
    // If bucket stopped by an assessment
    if (assessmentDetail && !assessmentDetail.drawJoin) {
      // Add classification from button model, if it exists
      if (assessmentDetail.classification) bucket['classification'] = { time_bucket_added: assessmentDetail.classification };
      // Add createdBy so we know which prompt this time bucket belongs to
      bucket['createdBy'] = assessmentDetail.createdBy || null;
    }
    // Not an assessment, set field_completed to true
    else {
      let key = Object.keys(fieldCompleted)[0] || 'value';
      fieldCompleted[key] = true;
    }
    if (typeKey === 's') {
      var parentKey = activeItemSplit[0];
      var sectionKey = activeItemSplit[1];
      item.multi_attributes = item.multi_attributes || {};
      item.multi_attributes.time_bucket = item.multi_attributes.time_bucket || {};
      item.multi_attributes.time_bucket[bucketKey] = bucket;
      item.multi_attributes.field_completed = fieldCompleted;
      GeofireTools.setGeohash('sections', item, parentKey, this.jobStyles, update, {
        sectionId: sectionKey,
        geoPath: `jobs/${job}/geohash/`
      });
      update['jobs/' + job + '/connections/' + parentKey + '/sections/' + sectionKey + '/multi_attributes/time_bucket/' + bucketKey] =
        bucket;
      update['jobs/' + job + '/connections/' + parentKey + '/sections/' + sectionKey + '/multi_attributes/field_completed/'] =
        fieldCompleted;
    } else if (typeKey === 'n') {
      var nodeKey = activeItemSplit[0];
      item.attributes = item.attributes || {};
      item.attributes.time_bucket = item.attributes.time_bucket || {};
      item.attributes.time_bucket[bucketKey] = bucket;
      item.attributes.field_completed = fieldCompleted;

      GeofireTools.setGeohash('nodes', item, nodeKey, this.jobStyles, update, {
        nodeConnections: SquashNulls(loadRenderMap.pointLocations[nodeKey], 'data', 'n'),
        geoPath: `jobs/${job}/geohash/`
      });
      update['jobs/' + job + '/nodes/' + nodeKey + '/attributes/time_bucket/' + bucketKey] = bucket;
      update['jobs/' + job + '/nodes/' + nodeKey + '/attributes/field_completed/'] = fieldCompleted;
    }

    let stopDate = this._formatDate(stopTime);
    ref.update(update, callback);
    return bucketKey;
  },

  _formatDate: function (date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }
});
